var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 5.21791C9.76918 5.21791 4.71803 10.2691 4.71803 16.5C4.71803 22.7309 9.76918 27.782 16.0001 27.782C22.231 27.782 27.2821 22.7309 27.2821 16.5C27.2821 10.2691 22.231 5.21791 16.0001 5.21791ZM2.66675 16.5C2.66675 9.13616 8.63629 3.16663 16.0001 3.16663C23.3639 3.16663 29.3334 9.13616 29.3334 16.5C29.3334 23.8638 23.3639 29.8333 16.0001 29.8333C8.63629 29.8333 2.66675 23.8638 2.66675 16.5Z",
    fill: "#F87B72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.077 22.5854C11.4169 23.0386 12.0597 23.1304 12.5129 22.7906C13.1298 22.3278 13.6355 22.0496 14.1465 21.8793C14.6574 21.709 15.2289 21.6282 16.0001 21.6282C16.7713 21.6282 17.3427 21.709 17.8537 21.8793C18.3646 22.0496 18.8703 22.3278 19.4873 22.7906C19.9404 23.1304 20.5833 23.0386 20.9232 22.5854C21.263 22.1323 21.1712 21.4894 20.718 21.1495C19.9839 20.599 19.2827 20.1934 18.5024 19.9333C17.722 19.6732 16.9177 19.5769 16.0001 19.5769C15.0824 19.5769 14.2782 19.6732 13.4978 19.9333C12.7174 20.1934 12.0162 20.599 11.2821 21.1495C10.829 21.4894 10.7371 22.1323 11.077 22.5854Z",
    fill: "#F87B72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.265 12.3974C13.265 13.1527 12.6528 13.7649 11.8975 13.7649C11.1423 13.7649 10.53 13.1527 10.53 12.3974C10.53 11.6421 11.1423 11.0299 11.8975 11.0299C12.6528 11.0299 13.265 11.6421 13.265 12.3974Z",
    fill: "#F87B72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4702 12.3974C21.4702 13.1527 20.8579 13.7649 20.1026 13.7649C19.3474 13.7649 18.7351 13.1527 18.7351 12.3974C18.7351 11.6421 19.3474 11.0299 20.1026 11.0299C20.8579 11.0299 21.4702 11.6421 21.4702 12.3974Z",
    fill: "#F87B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.ee014e9989380fb9b6b277caa3957eb4.svg";
export { ForwardRef as ReactComponent };